import React,{useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'; 
import CustomerChoice from '../customerChoice/CustomerChoice';
import { CustomerChoiceCompany } from '../customerChoice/CustomerChoiceCompany';
import Header from '../header/Header';
import { MobileMenu } from '../mobileMenu/MobileMenu';
import Menu from '../menu/Menu';
import '../customerTypePage/CustomerTypePage.css';
import red_line from '../../img/red_line.png'
import '../pageSize/PageSize.css';
import { FooterButtons } from '../common/buttons/FooterButtons';

export const CustomerTypePage = () => {
    const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);   
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isChoiceSelected, setIsChoiceSelected] = useState(false);
    const [isChoiceCompanySelected, setIsChoiceCompanySelected] = useState(false);

  
    const handleChoiceSelected = (fromComponent) =>{
     if(fromComponent === "CustomerChoice")
     {
      setIsChoiceSelected(true);
      setIsChoiceCompanySelected(false);
     }else if(fromComponent === "CustomerChoiceCompany")
     {
      setIsChoiceCompanySelected(true);
      setIsChoiceSelected(false);
     }

    }
    useEffect(() => {
        const handleWindowResize = () => {
            setIsMobile(window.matchMedia("(max-width: 767px)").matches);
        };
        window.addEventListener("resize", handleWindowResize);  
        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    return (
      <div className='page-size'>
        <Header/>
        {isMobile ? <MobileMenu isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/> : <Menu isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/>}

        <div className='client-type-container'>
          <div className='client-type-title-container'>
            <img style={{marginLeft: "0px"}} src={red_line} className="red-line"/>
            <p className='client-type-title-text'>Typ klienta</p>
          </div>
          <p className='client-type-choosing-container-title'>Wybierz typ klienta i rodzaj zgłoszenia</p>
          <div className='client-type-choosing-container'>
          
            <CustomerChoiceCompany
              onChoiceCompanySelected={()=>handleChoiceSelected("CustomerChoiceCompany")}
              isChoiceCompanySelected={isChoiceCompanySelected}
              isChoiceSelected={isChoiceSelected}
            />
            <CustomerChoice
              onChoiceSelected={()=>handleChoiceSelected("CustomerChoice")}
              isChoiceSelected={isChoiceSelected}
              isChoiceCompanySelected={isChoiceCompanySelected}
            />
          
          </div>
        </div>
      </div>
    )
}